import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'awardId',
                              },
                              '!code': {
                                '@$': 'awardCode',
                              },
                              '!fain': {
                                '@$': 'awardFain',
                              },
                              '!fan': {
                                '@$': 'awardFan',
                              },
                              '!name': {
                                '@$': 'awardName',
                              },
                              '!budget': {
                                '@$': 'awardBudget',
                              },
                              '!award_date': {
                                '@$': 'awardAwardDate',
                              },
                              '!sponsor': {
                                '{}': {
                                  entityId: 'ent:!sponsors:!sponsor',
                                  recordId: {
                                    '@$': 'awardSponsor',
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'ent:!awards:!award',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
